@if (control) {
  <mat-form-field appearance="outline" class="example-full-width mat-mdc-textarea">
    <mat-label>{{ label }}</mat-label>
    <textarea
      #textarea
      matInput
      [formControl]="control"
      [required]="required"
      [placeholder]="placeholder"
      cdkTextareaAutosize
      cdkAutosizeMinRows="2"
      cdkAutosizeMaxRows="8"
    ></textarea>
    @if (!control.pristine) {
      @for (error of control.errors | errorKeys; track error) {
        <mat-error>
          {{ messages[error] || error | translate }}
        </mat-error>
      }
    }
  </mat-form-field>
}
